import styled from 'styled-components';
import InputSearch from './InputSearch';
import { Checkbox } from 'antd';
import Text from 'components/Text';
import { useDispatch } from 'react-redux';
import settingServiceActions from 'features/settingService/services/actions';
import settingServiceSelectors from 'features/settingService/services/selectors';
import { IPermissionConfigRes } from 'features/settingService/services/types/permission';

const PermissionFilter = () => {

  const dispatch = useDispatch();
  const permissionConfig = settingServiceSelectors.getPermissionConfig();

  const onChange = (text: string) => {
    if(!permissionConfig) return;

    if(!text) {
      dispatch(settingServiceActions.updatePermissionConfigFiltered(permissionConfig));
    }

    const dataModuleFilter: IPermissionConfigRes[] = (permissionConfig ?? []).filter((permission) => {
      return permission.moduleName.toLowerCase().includes(text.toLowerCase()) || permission.features.some(feat => feat.featureName.toLowerCase().includes(text.toLowerCase()));
    });

    const dateFilter: IPermissionConfigRes[] = dataModuleFilter.map((permission) => {
      return {
        ...permission,
        features: permission.features.filter(feat => feat.featureName.toLowerCase().includes(text.toLowerCase()))
      };
    });
    dispatch(settingServiceActions.updatePermissionConfigFiltered(dateFilter));
    
  };

  return (
    <Row style={{gap: 24}}>
      <InputSearch onChange={onChange} />
      <Row>
        <CheckboxStyled
          checked={true}
        />
        <Text variant='CONTENT_3'>ALLOW</Text>
      </Row>
      <Row>
        <CheckboxStyled
          checked={false}
        />
        <Text variant='CONTENT_3'>NOT ALLOW</Text>
      </Row>
    </Row>
  );
};

export default PermissionFilter;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CheckboxStyled = styled(Checkbox)`
  pointer-events: none;
`;